//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
// import seo from '@/middleware/seo'

export default {
  name: 'AccountMyPlacesView',
  components: {
    Empty: () => import('@/components/common/Empty/index'),
    PlaceCard: () => import('@/components/common/PlaceCard/index'),
  },
  layout: 'personal-area',
  // middleware: [seo],
  head () {
    return {
      title: this.$t('pages.account-my-places.seo.title'),
      meta: this.$createSEOMeta({
        og: {
          type: 'website',
          image: this.SEOImage || this.$store.getters.host + '/meta-image-default-small.jpg?v=2',
          url: this.SEOUrl || this.$store.getters.host,
          locale: this.SEOLocale || `${this.$i18n.locale}_${this.$i18n.locale.toUpperCase()}`,
          site_name: this.SEOSiteName || this.$t('pages.index.seo.site-name'),
        },
        vk: {
          image: this.SEOImage || this.$store.getters.host + '/meta-image-default-small.jpg?v=2',
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      places: 'user/places',
      pending: 'user/placesPending'
    }),
  },
  created () {
    this.$store.dispatch('user/places', {
      clear: true,
      params: {
        lang: this.$i18n.locale,
        resolution: 'micro'
      }
    })
  }
}
